import { render, staticRenderFns } from "./CmMessage.vue?vue&type=template&id=72b96903&scoped=true&"
import script from "./CmMessage.vue?vue&type=script&lang=js&"
export * from "./CmMessage.vue?vue&type=script&lang=js&"
import style0 from "./CmMessage.vue?vue&type=style&index=0&id=72b96903&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b96903",
  null
  
)

export default component.exports